<section class="hero">
    <div class="container hero__container">
        <h1 class="hero__headline">
            <span class="hero__title">{{langDictionary.JOB_RESERVATION_FAIL.Title }}</span>
            <span class="hero__subtitle">{{ langDictionary.JOB_RESERVATION_FAIL.Subtitle  }}</span>
        </h1>
    </div>
</section>
<app-footer></app-footer>